import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

ReactDOM.render(
  <App
    calendarId="v7tbd2prfbjaqjpq7ujlughm3s@group.calendar.google.com"
    clientId="459216665265-rg4ujqcjinpgo3dlgqaori593ufgr8vr.apps.googleusercontent.com"
    apiKey="AIzaSyBGAE3BClVApBZVA-cXxImJgI2wWO_DStc"
  />,
  document.querySelector(".events-container")
);
